import React from "react";
import { LogOut, BarChart2, Building2 } from "lucide-react";

export type HeaderView = "analytics" | "admin";

const VIEWS: { key: HeaderView; label: string; icon: React.ReactNode }[] = [
  {
    key: "analytics",
    label: "Analytics",
    icon: <BarChart2 size={15} strokeWidth={2.2} />,
  },
  {
    key: "admin",
    label: "Admin",
    icon: <Building2 size={15} strokeWidth={2.2} />,
  },
];

export function Header({
  view,
  onView,
  adminName,
  onExit,
}: {
  view: HeaderView;
  onView: (v: HeaderView) => void;
  adminName: string;
  onExit: () => void;
}) {
  return (
    <div className="flex items-center justify-between gap-6 rounded-[11px] bg-[#123E32] px-9 py-8 text-white">
      <div className="flex flex-col gap-1">
        <h1 className="m-0 text-[30px] font-bold tracking-[-0.01em]">
          Hey{" "}
          <span className="font-libre-baskerville font-normal italic">
            {adminName},
          </span>
        </h1>
        <span className="text-sm font-normal text-white/70">
          District learning overview
        </span>
      </div>

      <div className="flex items-center gap-4">
        <div className="flex rounded-[8px] border border-white/20 bg-white/10 p-1">
          {VIEWS.map((v) => {
            const active = v.key === view;
            return (
              <button
                key={v.key}
                onClick={() => onView(v.key)}
                className={`flex cursor-pointer items-center gap-[7px] rounded-[6px] border-none px-[18px] py-2 text-sm font-semibold transition-colors duration-150 ${
                  active
                    ? "bg-[#FBF8F1] text-[#013D28]"
                    : "bg-transparent text-white/85"
                }`}
              >
                {v.icon}
                {v.label}
              </button>
            );
          })}
        </div>

        <button
          onClick={onExit}
          className="flex cursor-pointer items-center gap-2 rounded-[6px] border border-white/50 bg-transparent px-[18px] py-[9px] text-sm font-semibold text-white"
        >
          <LogOut size={16} strokeWidth={2} />
          Exit Dashboard
        </button>
      </div>
    </div>
  );
}
